import React, { useState } from "react"
import { css } from "emotion"
import ChipInput from "material-ui-chip-input"
import inviteToJam from "../util/fetchApiHelpers/inviteToJam"

export interface InviteModalProps {
	JAM_ID: string
	onClose: () => void
}

export default function InviteModal(props: InviteModalProps) {
	let [emails, setEmails] = useState(new Set<string>())
	let [submitting, setSubmitting] = useState(false)

	function handleAddEmail(email: string) {
		setEmails((emails) => {
			let copy = new Set(emails)
			copy.add(email)
			return copy
		})
	}

	function handleRemoveEmail(email: string) {
		setEmails((emails) => {
			let copy = new Set(emails)
			copy.delete(email)
			return copy
		})
	}

	async function handleSubmit() {
		setSubmitting(true)

		await inviteToJam(
			props.JAM_ID,
			Array.from(emails),
			`${window.location.protocol}//${window.location.host}`,
		)

		setEmails(new Set())
		setSubmitting(false)
		props.onClose()
	}

	return (
		<React.Fragment>
			<div
				className={css`
					display: flex;
					flex-direction: column;
					width: 630px;
					max-width: 90%;
					justify-content: center;
					height: fit-content;
					position: fixed;
					top: 0;
					bottom: 0;
					left: 0;
					right: 0;
					margin: auto;
					z-index: 1000002;
					background: #ffffff;
					box-sizing: border-box;
					box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
					border-radius: 2px;
					overflow: hidden;
					font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
						"Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
						"Helvetica Neue", sans-serif;
					color: #2a3632;
					padding: 3em 3.5em;
				`}
			>
				<img
					onClick={props.onClose}
					src="https://danigrant.github.io/img/close.svg"
					className={css`
						position: absolute;
						top: 1em;
						right: 1em;
						cursor: pointer;
					`}
				/>

				<h1
					className={css`
						font-size: 2em;
						display: flex;
						flex-direction: row;
						align-items: center;
					`}
				>
					Invite your team to{" "}
					<span>
						<img
							src="https://strawberryjam.nyc3.cdn.digitaloceanspaces.com/icon.png"
							className={css`
								width: 20px;
								display: flex;
								margin: 0 5px;
							`}
						/>
					</span>{" "}
					Jam
				</h1>
				<h2
					className={css`
						font-weight: 400;
						color: rgba(42, 54, 50, 0.5);
						margin-top: 0;
						font-size: 18px;
					`}
				>
					Enter their emails
				</h2>
				<div
					className={css`
						border: 1px solid rgba(42, 54, 50, 0.1);
						border-radius: 3px;
						box-sizing: border-box;
						margin: 10px 0;
					`}
				>
					<ChipInput
						value={Array.from(emails)}
						onAdd={handleAddEmail}
						onDelete={handleRemoveEmail}
						placeholder={`superwoman@${window.location.hostname}`}
						classes={{
							root: css`
								width: 100%;
								color: #2a3632;
								font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
									"Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
									"Droid Sans", "Helvetica Neue", sans-serif;
								font-size: 14px;
							`,
							chip: css`
								background: rgba(100, 175, 250, 0.1);
								color: #3c81c7;
								font-weight: 400;
								font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
									"Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
									"Droid Sans", "Helvetica Neue", sans-serif;
							`,
							chipContainer: css`
								width: 100%;
								padding: 10px 10px;
								color: #3c81c7;
								display: flex;
								align-self: center;
								font-weight: 400;
								font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
									"Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
									"Droid Sans", "Helvetica Neue", sans-serif;
							`,
						}}
						disableUnderline={true}
					/>
				</div>
				<button
					type="submit"
					onClick={handleSubmit}
					disabled={submitting}
					className={css`
						all: unset;
						box-sizing: border-box;
						width: 100%;
						background: #3776fd;
						border-radius: 5px;
						color: white;
						font-weight: 500;
						font-size: 1.5em;
						padding: 0.5em 1em;
						margin: 1rem 0 0;
						text-align: center;
						cursor: pointer;
					`}
				>
					{submitting ? "Invited! 💌" : "Invite"}
				</button>
			</div>

			<div
				onClick={props.onClose}
				className={css`
					background: rgba(0, 0, 0, 0.5);
					position: fixed;
					z-index: 1000001;
					width: 100%;
					height: 100vh;
					top: 0;
					left: 0;
				`}
			/>
		</React.Fragment>
	)
}
